import { render, staticRenderFns } from "./setMessagesPush.vue?vue&type=template&id=f191475e&scoped=true&"
import script from "./setMessagesPush.vue?vue&type=script&lang=js&"
export * from "./setMessagesPush.vue?vue&type=script&lang=js&"
import style0 from "./setMessagesPush.vue?vue&type=style&index=0&id=f191475e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f191475e",
  null
  
)

component.options.__file = "setMessagesPush.vue"
export default component.exports